export default {
  buttons: {
    title: "Indeling"
  },

}
